import PropTypes from 'prop-types'

const displayItem = PropTypes.shape({
    /**
     * Field from the data object to select
     */
    field: PropTypes.string,
    /**
     * A key to identify this display item
     */
    key: PropTypes.string,
    /**
     * Header label
     */
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    /**
     * If columns can be selected, it specifies its behavior on the selection/
     * `yes` is the default value and can be omited
     * `mandatory` removes the item from the selection and it is always being shown in the table
     * `hidden` shows the field to be selectable, but is not selected by default
     */
    selectable: PropTypes.oneOf(['yes', 'mandatory', 'hidden']), // If columns
    /**
     * Name to be displayed at the column selector.
     * If omited, it displays the label or the field name in the last case
     */
    name: PropTypes.string,
    /**
     * Set this item to be displayed only on mobile resolutions
     */
    onlyOnMobile: PropTypes.bool,
    /**
     * Set this item to be displayed only on large resolutions
     */
    onlyOnLG: PropTypes.bool,
    /**
     * Set this item to be displayed only on extra large resolutions
     */
    onlyOnXL: PropTypes.bool,
    /**
     * Cell props
     */
    props: PropTypes.shape({}),
    /**
     * Function to transform the field before rendering
     */
    transform: PropTypes.func,
    /**
     * Cell width
     */
    width: PropTypes.string,
})

// eslint-disable-next-line import/prefer-default-export
export { displayItem }
